(function($) {

$.fn.heroSlideShow = function( options ) {
	return this.each(function() {
		
		var settings = $.extend({
				timer: 7500,
				activeClass: 'active',
			}, options, $(this).data() ),
			
			$container = $(this),
			$slides = $container.children('.wp-block-metropolis-hero__slides').children(),
			$nav = $container.children('nav'),
			length = $slides.length,
			index = 0,
			timer = setInterval( nextSlide, settings.timer ),
			$controls = $("<nav>", { class: "controls" });
			
		function slideTo(idx) {
							
			$slides
				.removeClass( settings.activeClass )
				.eq(idx)
				.queue(function(next){
					$(this).addClass( settings.activeClass );
					next();
				});
							
			index = idx;
		}
			
		function nextSlide() {
			var nextIdx = index + 1 < length ? index + 1 : 0;
			slideTo(nextIdx);
		}

		var $controls = $("<nav>", { class: "wp-block-metropolis-hero__navigation" });
					
		$controls.append('<span class="prev"></span><span class="next"></span>').appendTo( $container );
		
		var $toggles = $controls.children();
		
		$toggles.on("click", function() {
			var idx = $slides.filter('.active').index(),
			    prevIdx = idx - 1 < 0 ? length - 1 : index - 1,
			    nextIdx = idx + 1 < length ? index + 1 : 0;
			slideTo( $(this).hasClass('prev') ? prevIdx : nextIdx);
			clearInterval(timer);
		});
		
		slideTo(index);
		
	});
};

$('.wp-block-metropolis-hero').heroSlideShow();

})(jQuery);